import React, { useState } from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import WithOnlyOnDesktop from '../../../components/onlyOnDesktop/withOnlyOnDesktop';
import AgencyProfessionalsCredentialList from './AgencyProfessionalsCredentialList';
import { useEnabledCredentialsQuery } from '../../../redux/external-agency';

import './AgencyProfessionalsCredentials.scss';

const AgencyProfessionalsCredentials = ({ caregiverId }) => {
	const [activeTabIndex, setActiveTabIndex] = useState(0);

	const { data, isFetching } = useEnabledCredentialsQuery(caregiverId, {
		refetchOnMountOrArgChange: true
	});
	const hasNotSubmittedPL =
		Array.isArray(data) &&
		data?.some((credential) => credential.credential_type === 'PROFESSIONAL_LICENSE' && !credential.submitted.length);

	return (
		<WithOnlyOnDesktop>
			<div className="credentials">
				<TabView activeIndex={activeTabIndex} onTabChange={(e) => setActiveTabIndex(e.index)}>
					<TabPanel header="All">
						<AgencyProfessionalsCredentialList
							caregiverId={caregiverId}
							primaryLicense={!isFetching && hasNotSubmittedPL}
						/>
					</TabPanel>
				</TabView>
			</div>
		</WithOnlyOnDesktop>
	);
};

export default AgencyProfessionalsCredentials;
